export default [
  { key: "{{d.comum.dataAtual}}", description: "Data atual (curta)" },
  { key: "{{d.comum.dataAtualExtenso}}", description: "Data atual por extenso" },
  { key: "{{d.comum.horaAtual}}", description: "Hora atual" },

  { key: "{{d.locacao.numero}}", description: "Numero da locacao" },
  { key: "{{d.locacao.dataEfetivacao}}", description: "Data de efetivacao" },
  { key: "{{d.locacao.dataCadastro}}", description: "Data de cadastro" },
  { key: "{{d.locacao.horaCadastro}}", description: "Hora do cadastro" },
  { key: "{{d.locacao.identificacao}}", description: "Identificacao da locacao" },
  { key: "{{d.locacao.tipoLocacao}}", description: "Tipo da locacao" },
  { key: "{{d.locacao.obsLocacao}}", description: "Observacoes da locacao" },
  { key: "{{d.locacao.obsOs}}", description: "Observacoes da OS" },
  { key: "{{d.locacao.motivoReprovacao}}", description: "Motivo da reprovação" },
  { key: "{{d.locacao.total}}", description: "Total da locacao" },
  { key: "{{d.locacao.totalExtenso}}", description: "Total por extenso" },
  { key: "{{d.locacao.totalCusto}}", description: "Total de custo" },
  { key: "{{d.locacao.totalCustoExtenso}}", description: "Total custo por extenso" },
  { key: "{{d.locacao.totalReposicao}}", description: "Total de reposicao" },
  { key: "{{d.locacao.totalReposicaoExtenso}}", description: "Total de reposicao por extenso" },
  { key: "{{d.locacao.totalDesconto}}", description: "Total de desconto" },
  { key: "{{d.locacao.totalDescontoExtenso}}", description: "Total de desconto por extenso" },

  { key: "{{d.locacao.cliente.razaoSocialNome}}", description: "Razao social / Nome" },
  { key: "{{d.locacao.cliente.fantasiaApelido}}", description: "Nome fantasia / Apelido" },
  { key: "{{d.locacao.cliente.cnpjCpfTitulo}}", description: "Titulo CNPJ/CPF" },
  { key: "{{d.locacao.cliente.cnpjCpf}}", description: "CNPJ/CPF" },
  { key: "{{d.locacao.cliente.irTitulo}}", description: "Titulo IE" },
  { key: "{{d.locacao.cliente.ir}}", description: "Inscricao Estadual" },
  { key: "{{d.locacao.cliente.im}}", description: "Inscricao Municipal" },
  { key: "{{d.locacao.cliente.cep}}", description: "CEP" },
  { key: "{{d.locacao.cliente.rua}}", description: "Rua" },
  { key: "{{d.locacao.cliente.numero}}", description: "Numero" },
  { key: "{{d.locacao.cliente.complemento}}", description: "Complemento" },
  { key: "{{d.locacao.cliente.bairro}}", description: "Bairro" },
  { key: "{{d.locacao.cliente.cidade}}", description: "Cidade" },
  { key: "{{d.locacao.cliente.estado}}", description: "Estado" },
  { key: "{{d.locacao.cliente.telefone}}", description: "Telefone" },
  { key: "{{d.locacao.cliente.site}}", description: "Site" },
  { key: "{{d.locacao.cliente.email}}", description: "E-mail" },

  { key: "{{d.locacao.colaborador.nome}}", description: "Nome do colaborador" },
  { key: "{{d.locacao.colaborador.apelido}}", description: "Apelido" },
  { key: "{{d.locacao.colaborador.celular}}", description: "Celular" },
  { key: "{{d.locacao.colaborador.email}}", description: "E-mail do colaborador" },

  { key: "{{d.locacao.contato.nome}}", description: "Nome do contato" },
  { key: "{{d.locacao.contato.celular}}", description: "Celular do contato" },
  { key: "{{d.locacao.contato.email}}", description: "E-mail do contato" },

  { key: "{{d.periodo.inicioFim}}", description: "Periodo de inicio e fim" },
  { key: "{{d.periodo.entregaRetirada}}", description: "Periodo de entrega e retirada" },

  { key: "{{d.pagamentoLocacao}}", description: "Forma de pagamento (locacao)" },
  { key: "{{d.pagamentoFaturar}}", description: "Forma de pagamento (faturar)" }
];

